// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobForm_title__G0j8D {
  font-size: 18px;
  font-weight: 300;
  line-height: 1.78;
  color: #767676;
}

.JobForm_moNumberFormFeedback__CG1ka {
  color: red !important;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/JobForm/JobForm.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".title {\r\n  font-size: 18px;\r\n  font-weight: 300;\r\n  line-height: 1.78;\r\n  color: #767676;\r\n}\r\n\r\n.moNumberFormFeedback {\r\n  color: red !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `JobForm_title__G0j8D`,
	"moNumberFormFeedback": `JobForm_moNumberFormFeedback__CG1ka`
};
export default ___CSS_LOADER_EXPORT___;
